import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import Login from './pages/login/Login';
import Cadastro from './pages/login/cadastro/cadastro';
import PrimeiroAcesso from './pages/login/primeiroAcesso/primeiroAcesso';
import Intro from './pages/intro/intro';
import CardProdutoPage from './pages/cardprodutopage/CardProdutoPage';
import ResultadoBusca from './pages/resultadobusca/ResultadoBusca';
import Categorias from './pages/categorias/Categorias';
import OfertasDaSemana from './pages/ofertasdasemana/OfertasDaSemana';
import Food from './pages/food/Food';
import Frios from './pages/frios/Frios';
import PortalCandidato from './pages/candidato/portalcandidato/PortalCandidato';
import Vaga from './pages/candidato/vaga/Vaga';
import Candidatar from './pages/candidato/candidatar/Candidatar';
import Representantes from './pages/candidato/representante/Representantes';
import QuemSomos from './pages/quemsomos/QuemSomos';
import ComoComprar from './pages/comocomprar/ComoComprar';
import PoliticaDePrivacidade from './pages/politicadeprivacidade/PoliticaDePrivacidade';
import IntroBlog from './pages/blogeliandro/introblog/IntroBlog';
import Marcas from './pages/marcas/Marcas';
import NovaSenha from './pages/login/novasenha/NovaSenha';
import LoginAbastRua from './pages/abastecimento/loginabastecerua/loginAbastRua';
import AbasteceRua from './pages/abastecimento/abstecerua/AbasteceRua';
import Carrinho from './pages/carrinho/Carrinho';
import DadosCliente from './pages/dados/dadoscliente/DadosCliente';
import AdminEccomerce from './pages/adminEccomerce/AdminEccomerce';
import Pedidos from './pages/dados/pedidos/Pedidos';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: white;
    font-family: Arial, sans-serif;
  }
`;
//<Intro/>
const router = createBrowserRouter([
  { path: "/", element: <Intro/>  },
  { path: "/login", element: <Login/> },
  { path: "/cadastro", element: <Cadastro/> },
  { path: "/primeiroacesso", element: <PrimeiroAcesso/> },
  { path: "/cardproduto/:coditem", element: <CardProdutoPage/> },
  { path: "/busca/:dados", element: <ResultadoBusca/> },
  { path: "/categorias/:codgrupo", element: <Categorias/> },
  { path: "/ofertasdasemana", element: <OfertasDaSemana/> },
  { path: "/food", element: <Food/> },
  { path: "/frios", element: <Frios/> },
  { path: "/portalcandidato", element: <PortalCandidato/> },
  { path: "/vaga/:id", element: <Vaga /> },
  { path: "/candidatar", element: <Candidatar/> },
  { path: "/seja-um-representante", element: <Representantes/> },
  { path: "/quemsomos", element: <QuemSomos/> },
  { path: "/comocomprar", element: <ComoComprar/> },
  { path: "/politica-de-privacidade", element: <PoliticaDePrivacidade/> },
  { path: "/blog-eliandro", element: <IntroBlog/> },
  { path: "/marcas/:nome", element: <Marcas/> },
  { path: "/novasenha", element: <NovaSenha/> },
  { path: "/logrua", element: <LoginAbastRua/> },
  { path: "/abastece", element: <AbasteceRua/> },
  { path: "/carrinho", element: <Carrinho/> },
  { path: "/dados", element: <DadosCliente/> },
  { path: "/admin", element: <AdminEccomerce/> },
  { path: "/pedidos", element: <Pedidos/> }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <RouterProvider router={router} />
  </React.StrictMode>
);

document.title = "ELIANDRO ALIMENTOS";

/*
import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import { createGlobalStyle } from "styled-components";

import Login from "./pages/login/Login";
import Cadastro from "./pages/login/cadastro/cadastro";
import PrimeiroAcesso from "./pages/login/primeiroAcesso/primeiroAcesso";
import Intro from "./pages/intro/intro";
import CardProdutoPage from "./pages/cardprodutopage/CardProdutoPage";
import ResultadoBusca from "./pages/resultadobusca/ResultadoBusca";
import Categorias from "./pages/categorias/Categorias";
import OfertasDaSemana from "./pages/ofertasdasemana/OfertasDaSemana";
import Food from "./pages/food/Food";
import Frios from "./pages/frios/Frios";
import PortalCandidato from "./pages/candidato/portalcandidato/PortalCandidato";
import Vaga from "./pages/candidato/vaga/Vaga";
import Candidatar from "./pages/candidato/candidatar/Candidatar";
import Representantes from "./pages/candidato/representante/Representantes";
import QuemSomos from "./pages/quemsomos/QuemSomos";
import ComoComprar from "./pages/comocomprar/ComoComprar";
import PoliticaDePrivacidade from "./pages/politicadeprivacidade/PoliticaDePrivacidade";
import IntroBlog from "./pages/blogeliandro/introblog/IntroBlog";
import Marcas from "./pages/marcas/Marcas";
import NovaSenha from "./pages/login/novasenha/NovaSenha";
import LoginAbastRua from "./pages/abastecimento/loginabastecerua/loginAbastRua";
import AbasteceRua from "./pages/abastecimento/abstecerua/AbasteceRua";
import Carrinho from "./pages/carrinho/Carrinho";
import DadosCliente from "./pages/dados/dadoscliente/DadosCliente";
import AdminEccomerce from "./pages/adminEccomerce/AdminEccomerce";
import Pedidos from "./pages/dados/pedidos/Pedidos";

const GlobalStyle = createGlobalStyle`
  body {
    background-color: white;
    font-family: Arial, sans-serif;
  }
`;

const router = createHashRouter([
  { path: "/", element: <Intro /> },
  { path: "/login", element: <Login /> },
  { path: "/cadastro", element: <Cadastro /> },
  { path: "/primeiroacesso", element: <PrimeiroAcesso /> },
  { path: "/cardproduto/:coditem", element: <CardProdutoPage /> },
  { path: "/busca/:dados", element: <ResultadoBusca /> },
  { path: "/categorias/:codgrupo", element: <Categorias /> },
  { path: "/ofertasdasemana", element: <OfertasDaSemana /> },
  { path: "/food", element: <Food /> },
  { path: "/frios", element: <Frios /> },
  { path: "/portalcandidato", element: <PortalCandidato /> },
  { path: "/vaga/:id", element: <Vaga /> },
  { path: "/candidatar", element: <Candidatar /> },
  { path: "/seja-um-representante", element: <Representantes /> },
  { path: "/quemsomos", element: <QuemSomos /> },
  { path: "/comocomprar", element: <ComoComprar /> },
  { path: "/politica-de-privacidade", element: <PoliticaDePrivacidade /> },
  { path: "/blog-eliandro", element: <IntroBlog /> },
  { path: "/marcas/:nome", element: <Marcas /> },
  { path: "/novasenha", element: <NovaSenha /> },
  { path: "/logrua", element: <LoginAbastRua /> },
  { path: "/abastece", element: <AbasteceRua /> },
  { path: "/carrinho", element: <Carrinho /> },
  { path: "/dados", element: <DadosCliente /> },
  { path: "/admin", element: <AdminEccomerce /> },
  { path: "/pedidos", element: <Pedidos /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GlobalStyle />
    <RouterProvider router={router} />
  </React.StrictMode>
);

document.title = "ELIANDRO ALIMENTOS";
*/